export default __webpack_public_path__ + "static/media/FAQ.160438fe.svg";